import { proxy } from 'valtio'
import { IFilteredMetrics } from '../../shared/lib/utils.ts'
import { PracticeApi } from '../../shared/api/practiceApi.ts'
import { createStoreContext, useStoreContext } from '../../shared/lib/hooks.ts'
import { AccountHints, ChatApi } from 'src/shared/api/chatApi.ts'

interface State {
  programs: IFilteredMetrics | []
  words: {
    loading: boolean
    count: number | null
  }
  stat: { new: number; weak: number; strong: number; sum: number } | null
  hints: AccountHints | null
  tourStepIndex: number
}

export class PracticeStore {
  state: State

  constructor(
    private practiceApi: PracticeApi,
    private chatApi: ChatApi,
  ) {
    this.state = proxy<State>({
      words: {
        loading: false,
        count: null,
      },
      stat: null,
      programs: [],
      hints: null,
      tourStepIndex: 0,
    })
  }

  async getPrograms() {
    return await this.practiceApi.getPracticePrograms()
  }

  async getPracticeInfo() {
    try {
      this.state.words.loading = true
      const hints = await this.chatApi.getHints()
      if (Object.keys(hints).length) {
        this.state.hints = hints
      }
      const statistics = await this.practiceApi.getVocabStat()
      this.state.words.count = statistics.total
      this.state.stat = {
        ...statistics,
        sum: statistics.new + statistics.strong + statistics.weak,
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.state.words.loading = false
    }
  }

  async deleteMarketingHints() {
    await this.chatApi.deleteHint('marketingPracticeHint')
    this.state.hints = null
  }

  setTourIndex(index: number) {
    this.state.tourStepIndex = index
  }
}

export const PracticeStoreContext = createStoreContext<PracticeStore>()

export function usePracticeStore() {
  return useStoreContext(PracticeStoreContext)
}
